import { EventInput } from '@fullcalendar/core';
import {
  CalendarEventModel,
  CalendarEventType,
} from '../../../../../../api-service/clients';
import { mapServiceProviderCalendarEvent } from '../../../../../service-provider-unit-calendar/_shared/service-provider-calendar-event-mapper';
import { mapAssignmentFollowUpCalendarEvent } from './assignment-follow-up-calendar-event-mapper';
import { mapBookingCalendarEvent } from './booking-calendar-event-mapper';
import { mapMedicineCalendarEvent } from './medicine-calendar-event-mapper';

export function mapCalendarEvents(
  events: CalendarEventModel[],
  citizenId: string,
  serviceProviderUnitId?: string
): EventInput[] {
  const bookings = events.filter(
    event => event.type === CalendarEventType.Booking
  );
  const assignmentFollowUps = events.filter(
    event => event.type === CalendarEventType.AssignmentFollowUp
  );
  const serviceProviderEvents = events.filter(
    event => event.type === CalendarEventType.Event
  );
  const medicineDoses = events.filter(
    event => event.type === CalendarEventType.Medicine
  );

  const mappedBookings = bookings.map(event => mapBookingCalendarEvent(event));
  const mappedAssignmentFollowUps = assignmentFollowUps.map(event =>
    mapAssignmentFollowUpCalendarEvent(event, citizenId, serviceProviderUnitId)
  );
  const mappedServiceProviderEvents = serviceProviderEvents.map(event =>
    mapServiceProviderCalendarEvent({ ...event, citizenId, serviceProviderUnitId })
  );
  const mappedMedicineDoses = medicineDoses.map(event =>
    mapMedicineCalendarEvent(event)
  );

  return [
    ...mappedBookings,
    ...mappedAssignmentFollowUps,
    ...mappedServiceProviderEvents,
    ...mappedMedicineDoses,
  ].filter(event => event !== null);
}
